import MultiStepForm from '@/components/forms/MultiStepForm';
import GeneralUserSubscriptions from '@/components/forms/apps/GeneralUserSubscriptions';
import tenant from '@/services/TenantService';
import { toast } from 'react-toastify';
import ToastMessage from '@/components/toasts/ToastMessage';

export default function CallcenterSetup({
  app,
  onFinish,
  onCancel,
  deployment,
}) {
  const depl = deployment || {};
  const steps = [<GeneralUserSubscriptions key="userSubcriptions" app={app} />];

  const handleSubmit = async (formData, users) => {
    const deploymentData = {
      app: app._id,
      config: formData,
    };
    try {
      const deploymentResponse = await tenant.put(
        `/deployment/${depl.insertedId}`,
        deploymentData,
      );
      const { deployment } = deploymentResponse.data;
      await tenant.post('/subscription', {
        userIds: users,
        deploymentId: depl.insertedId,
      });

      onFinish(deployment, users);
    } catch (error) {
      toast.error(
        <ToastMessage
          title="Fehler"
          subtitle={
            error?.response?.data?.message ||
            'Fehler beim Erstellen der Konfiguration'
          }
        />,
      );
    }
  };

  return (
    <MultiStepForm steps={steps} onSubmit={handleSubmit} onCancel={onCancel} />
  );
}
